<template>
    <div style="margin-top:60px;">
        <el-carousel :interval="5000" trigger="click" :height="bannerH +'px'">
            <el-carousel-item v-for="item of list" :key="item.id">
                <img :src="item" class="bannerImg">
            </el-carousel-item>
        </el-carousel>
    </div>
</template>
<script>
export default {
  name: 'HomeBanner',
  props: {
    list: Array
  },
  data () {
      return {
          bannerH:200,
      }
  },
    methods:{
        setBannerH(){
            this.bannerH = document.body.clientWidth / 3.2
        }
    },
    mounted(){
        this.setBannerH();
        window.addEventListener('resize', () => {
            this.setBannerH()
        }, false)
    },
}
</script>
<style>
    .bannerImg{width: 100%;height:auto;}
</style>
